export const formatPhone = value => {
    const val = value.replace(/(?!\+)[^0-9]/g, "")
    const testValue = val.slice(1)
    return val.length ? val[0] + testValue.replace('+', '') : ''
}
